import doctorPhoto from "../assets/dr-carlos-soto-hero.jpg";

export default function Inicio({ onNav }) {
  return (
    <section className="bg-navy-600 px-6 md:px-8 pt-10 pb-8">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-6 items-start">

        {/* Left */}
        <div className="flex-1">
          <div className="inline-flex items-center gap-1.5 bg-codelco/20 border border-codelco/35 text-codelco-light text-[10px] font-medium px-3 py-1 rounded-full mb-4 uppercase tracking-wider">
            ⚙ Contraloría Dental · Codelco Teniente
          </div>

          <h1 className="font-display text-2xl md:text-3xl font-bold text-white leading-tight mb-3">
            Bienvenidos a la{" "}
            <span className="text-codelco-light">Contraloría Dental</span>{" "}
            de Codelco Teniente
          </h1>

          <p className="text-white/65 text-sm leading-relaxed mb-6 max-w-md">
            Nuestras oficinas están ubicadas en{" "}
            <span className="text-white/80 font-medium">
              Avenida Miguel Ramírez #140
            </span>
            , frente a la Isapre Colmena, Rancagua.
          </p>

          <div className="flex flex-wrap gap-3">
            <button
              onClick={() => onNav("protocolo")}
              className="btn-primary flex items-center gap-2"
            >
              📋 Ver Protocolo de Solicitud
            </button>
            <button
              onClick={() => onNav("descargas")}
              className="btn-ghost flex items-center gap-2"
            >
              📥 Descargas y Links
            </button>
          </div>

          {/* Tutorial link */}
          <p className="text-white/45 text-xs mt-5">
            Video tutorial del proceso:{" "}
            <a
              href="https://www.youtube.com/watch?v=Shb7dQikyDc"
              target="_blank"
              rel="noreferrer"
              className="text-codelco-light hover:underline"
            >
              Ver en YouTube →
            </a>
          </p>
        </div>

        {/* Right cards */}
        <div className="flex flex-col gap-3 w-full md:w-56 flex-shrink-0">
          <div className="bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
            <img
              src={doctorPhoto}
              alt="Dr. Carlos Eduardo Soto Pérez"
              className="w-full h-72 object-cover object-[center_10%] brightness-95 contrast-110 saturate-95"
            />
            <div className="p-4 border-t border-white/10">
              <div className="text-white/40 text-[10px] uppercase tracking-widest mb-1.5">
                Dentista Contralor
              </div>
              <div className="text-white text-sm font-medium leading-snug">
                Dr. Carlos Eduardo Soto Pérez
              </div>
            </div>
          </div>

          {/* 85% badge */}
          <div className="bg-codelco/15 border border-codelco/30 rounded-xl p-4 flex items-center gap-4">
            <div className="font-display text-4xl font-bold text-codelco-light leading-none">
              85%
            </div>
            <div className="text-white/65 text-[11px] leading-snug">
              de reembolso para personal rol "A" y sus cargas familiares
            </div>
          </div>

          {/* Horarios */}
          <div className="bg-white/10 border border-white/10 rounded-xl p-4">
            <div className="text-white/40 text-[10px] uppercase tracking-widest mb-2">
              Horarios de atención
            </div>
            <div className="text-white text-xs font-medium leading-relaxed">
              Lunes a viernes{" "}
              <span className="text-white/55 font-normal">tarde</span>
              <br />
              <span className="text-white/80">17:00 – 19:30 hrs</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
